import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { 
  IAllOpportunityAPIModel, 
  IFilterItemModel, 
  IFilterAPIModel,
  IPillsAPIModel, 
  IPaginationModel, 
  ISortModel,
  ISamplingStatusAPIModel,
  IOpportunityAPIDataModel, 
  IAnomaliesFilterModel} from '../models/IAllOpportunitiesModel';
import { GenericState } from './ISliceInterfaces';
import axios from '../utils/APIUtils';
import { OPPORTUNITIES_API_PATHS, FILTER_GROUP_NAMES, STATUS_MAPPING_DISPLAY, USER_ROLE } from '../constants/constants';
import { IAnomalyCommentsResponseModel,IQuickSummaryTypeModel,IViewTypeModel } from '../models/IOpportunitiesAPIModel';
import { isOverviewDashboard } from 'src/utils/dashboardUtilis';
import { mapFilterColumns } from 'src/utils/filterUtils';


export const initialState = {
  records: { status: 'idle' } as GenericState<IAllOpportunityAPIModel>,
  record: { status: 'idle' } as GenericState<IAllOpportunityAPIModel>,
  currentInsightId: null,
  detailedView:"",
  lastPageBeforeLandingDetailedPage:1,
  filter: [] as IFilterItemModel[],
  sort: { columnName: null, orderBy: 'asc' } as ISortModel,
  pills: { status: 'idle' } as GenericState<IPillsAPIModel[]>,
  statuslookup: { status: 'idle' } as GenericState<IAnomaliesFilterModel[]>,
  samplingstatus: {status: 'idle'} as GenericState<ISamplingStatusAPIModel>,
  comments: { status: 'idle' } as GenericState<IAnomalyCommentsResponseModel>,
  pagination: { itemPerpage: 10, currentPage: 1 } as IPaginationModel,
  export: { loading: false },
  quicksummarytype:{ quickSummaryType: '' } as IQuickSummaryTypeModel,
  reviewerOptionsRx: [],
  viewType:{ viewType: '' } as IViewTypeModel,
  dashbaordfilter: [] as IFilterAPIModel[],
  anomaliesFilters :[] as IFilterAPIModel[],
  exportFilters :[] as IFilterAPIModel[],
  exportData: {status: 'idle'} as GenericState<any>,
  postFilters:[] as IFilterAPIModel[],
  referenceToggle: true,
};

/** Get All Opportunities */
export const getallOpportunities = createAsyncThunk('opportunities/getallOpportunities', async (arg, thunkAPI) => {
  const store: any = thunkAPI.getState();
  const currentRole : string =store.onBoarding.currentRole || sessionStorage.getItem("role");
  const postFilters:boolean = store.allOpportunities.postFilters;
  let data: any = {}
  if (isOverviewDashboard(store.overview.overviewViewType.viewType) && store.allOpportunities.quicksummarytype.quickSummaryType.length===0 && currentRole !==null
  ) {
    data["view_type"] = store.overview.overviewViewType.viewType;
    let basicFilter: any = buildFilterRequest([], store.allOpportunities.pagination, store.allOpportunities.sort, store.allOpportunities.quicksummarytype.quickSummaryType,currentRole);
    data["filters"] = mapFilterColumns([...store.allOpportunities.dashbaordfilter.filter((item:any)=>{
      return !item.value.includes("All") && !item.value.includes("all") ;
    }), ...basicFilter.filters]);
    data["page"]= basicFilter.page;
    data["rows_per_page"]=basicFilter.rows_per_page;
    data["sort"] =basicFilter.sort;
    data["current_role"]=currentRole || sessionStorage.getItem("role");
  }
  else {
    data = buildFilterRequest(store.allOpportunities.anomaliesFilters, store.allOpportunities.pagination, store.allOpportunities.sort, store.allOpportunities.quicksummarytype.quickSummaryType,currentRole);
  }

  if (Array.isArray(postFilters) && postFilters.length > 0) data = { ...data, postFilters };
  const response = await axios.post<IAllOpportunityAPIModel>(OPPORTUNITIES_API_PATHS.opportunities, data);
  return response.data;
});


export const getCurrentOpportunities = createAsyncThunk('opportunities/getCurrentOpportunities', async (arg, thunkAPI) => {
  const store: any = thunkAPI.getState();
  const currentid = store.allOpportunities.currentInsightId;
  let data: any = {}
  let datafilter = [{
    column: "insight_id",
    type: "eq",
    value: currentid
  }]
  data["filters"] = datafilter;
  data["page"] = 1;
  data["rows_per_page"] = 1;
  data["sort"] = {};
  data["current_role"]=store.onBoarding.currentRole || sessionStorage.getItem("role");
  const response = await axios.post<IAllOpportunityAPIModel>(OPPORTUNITIES_API_PATHS.opportunities, data);
  return response.data;
});

/** Get Pills */
export const getStatusPills = createAsyncThunk('opportunities/getStatusPills', async (arg, thunkAPI) => {
  const store: any = thunkAPI.getState();
  const response = await axios.get<IPillsAPIModel[]>(`${OPPORTUNITIES_API_PATHS.statusPills}?current_role=${store.onBoarding.currentRole}`);
  const arrData = await manipulateStatusToDisplay(store, response.data)
  return arrData;
});

/** Get lookup status */
export const getLookupStatus = createAsyncThunk('opportunities/getLookupStatus', async (arg,thunkAPI) => {
  const store: any = thunkAPI.getState();
  const currentRole : string =store.onBoarding.currentRole || sessionStorage.getItem("role");
  const lookupStatusData = {"current_role": currentRole}
  const response = await axios.post<IAnomaliesFilterModel[]>(OPPORTUNITIES_API_PATHS.lookupStatus,lookupStatusData);
  return response.data;
});

/** Get Export Lookup */
export const getExportLookup = createAsyncThunk('opportunities/getExportLookup', async (data: any) => {
  const response = await axios.post<any>(OPPORTUNITIES_API_PATHS.exportLookup, data);
  return response.data;
});

/** Get sampling status*/

export const getSamplingStatus = createAsyncThunk('opportunities/getSamplingStatus', async (arg,thunkAPI) => {
  const store: any = thunkAPI.getState();
  const currentRole : string =store.onBoarding.currentRole || sessionStorage.getItem("role");
  const samplingStatusData = {"current_role": currentRole}
  const response = await axios.post<ISamplingStatusAPIModel>(OPPORTUNITIES_API_PATHS.samplingStatus,samplingStatusData);
  return response.data;
});


// /** Get sampling count*/

// export const getSamplingCount = createAsyncThunk('opportunities/getSamplingCount', async () => {
//   const response = await axios.get<ISamplingCountAPIModel>(OPPORTUNITIES_API_PATHS.samplingCount);
//   return response.data;
// });

const manipulateStatusToDisplay = (store: any, data: IPillsAPIModel[]) => {
  const resData: any = {};
  let arrData: any = [];
  if (data.length > 0) {
    const roles: any = store.onBoarding?.onBoardingData?.data?.roles;
    if (roles && roles.length > 0) {
      for (let i in data) {
        const value = STATUS_MAPPING_DISPLAY[roles[0]]['uimap'][data[i].status];
        if (value) {
          if (resData[value]) {
            resData[value] = resData[value] + data[i].row_count;
          } else {
            resData[value] = data[i].row_count;
          }
        }
      }
      Object.keys(resData).forEach((i, index) => arrData.push({ 'status': i, 'row_count': resData[i] }));
      return arrData;
    }
  }
}

export const getCommentsDetail = createAsyncThunk('opportunities/userActivity', async (opportunityId: number) => {
  const response = await axios.get<IAnomalyCommentsResponseModel>(`${OPPORTUNITIES_API_PATHS.opportunities}/${opportunityId}/user-activity`);
  return response.data;
});

export const allOpportunitiesSlice = createSlice({
  name: 'allOpportunities',
  initialState,
  reducers: {
    addFilter: (state, action) => {
      const data = action.payload;
      let updatedFilters = [...state.anomaliesFilters].filter((filter: any)=> filter.column !== data.column);
      const validData = [...updatedFilters, data].filter(el => el.value.length > 0);
      state.filter = validData;
      state.anomaliesFilters = validData;
    },

    addDashboardFilter: (state, action) => {
      state.dashbaordfilter = [];
      state.anomaliesFilters =[];
      state.dashbaordfilter = action.payload;
    },
    clearAllFilters: (state, action) => {
      state.filter = [];
      state.anomaliesFilters =[];
      state.dashbaordfilter = [];
    },
    removeMasterSearchFilter: (state, action) => {
      const searchRemoved = ([...state.filter]).filter((item, index) => FILTER_GROUP_NAMES.SEARCH !== item.groupName)
      state.filter = searchRemoved;
    },
    addSort: (state, action) => {
      const data = action.payload;
      state.sort.columnName = data.columnName;
      state.sort.orderBy = data.orderBy;
    },
    removeSort: (state) => {
      state.sort.columnName = null;
    },
    setPaginationCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload
    },
    setReviewerOptionsRx: (state, action) => {
      state.reviewerOptionsRx = action.payload;
    },
    setPaginationItemPerPage: (state, action) => {
      state.pagination.itemPerpage = action.payload
    },
    setExportStatus: (state, action) => {
      state.export.loading = action.payload;
    },
    setQuickSummaryType: (state, action) => {
      state.quicksummarytype.quickSummaryType = action.payload;
    },
    setViewType: (state, action) => {
      state.viewType.viewType = action.payload;
    },
    setCurrentInsightID: (state, action) => {
      state.currentInsightId = action.payload;
    },
    setDetailedView: (state, action) => {
      state.detailedView = action.payload;
    },
    setLastPageBeforeLandingDetailedPage: (state, action) => {
      state.lastPageBeforeLandingDetailedPage = action.payload;
    },
    addAllAnomalyFilters: (state, action) => {
      state.anomaliesFilters= action.payload;
    },
    addExportFilter:(state,action)=>{
      state.exportFilters = action.payload
    },
    setPostFilters:(state,{payload:postFilters})=>{
      return {...state, postFilters};
    },
    setReferenceToggle:(state,{payload:referenceToggle})=>{
      return {...state, referenceToggle};
    },
    setCommentStatus:(state,{payload:status})=>{
      return {...state, comments:{...state.comments,status}};
    },
    clearExportFilter:(state,action)=>{
      state.exportFilters = []
    }
  },
  extraReducers: builder => {
    builder.addCase(getallOpportunities.pending, (state) => {
      state.records.status = 'loading';
    });
    builder.addCase(getallOpportunities.fulfilled, (state, action) => {
      state.records.status = 'finished';
      state.records.data = action.payload;
    });
    builder.addCase(getallOpportunities.rejected, (state) => {
      state.records.status = 'error';
    });
    builder.addCase(getCurrentOpportunities.pending, (state) => {
      state.record.status = 'loading';
    });
    builder.addCase(getCurrentOpportunities.fulfilled, (state, action) => {
      state.record.status = 'finished';
      state.record.data = action.payload;
    });
    builder.addCase(getCurrentOpportunities.rejected, (state) => {
      state.record.status = 'error';
    });
    builder.addCase(getStatusPills.pending, (state) => {
      state.pills.status = 'loading';
    });
    builder.addCase(getStatusPills.fulfilled, (state, action) => {
      state.pills.status = 'finished';
      state.pills.data = action.payload;
    });
    builder.addCase(getStatusPills.rejected, (state) => {
      state.pills.status = 'error';
    });
    builder.addCase(getCommentsDetail.pending, (state) => {
      state.comments.status = 'loading';
    });
    builder.addCase(getCommentsDetail.fulfilled, (state, action) => {
      state.comments.status = 'finished';
      state.comments.data = action.payload;
    });
    builder.addCase(getCommentsDetail.rejected, (state) => {
      state.comments.status = 'error';
    });

    builder.addCase(getLookupStatus.pending, (state) => {
      state.statuslookup.status = 'loading';
    });
    builder.addCase(getLookupStatus.fulfilled, (state:any, action : any) => {
      state.statuslookup.status = 'finished';
      state.statuslookup.data = action.payload;
    });
    builder.addCase(getLookupStatus.rejected, (state) => {
      state.statuslookup.status = 'error';
    });
    //Reducers for Sampling Status
    builder.addCase(getSamplingStatus.pending, (state) => {
      state.samplingstatus.status = 'loading';
    });
    builder.addCase(getSamplingStatus.fulfilled, (state, action) => {
      state.samplingstatus.status = 'finished';
      state.samplingstatus.data = action.payload;
    });
    builder.addCase(getSamplingStatus.rejected, (state) => {
      state.samplingstatus.status = 'error';
    });
    //Reducers for Export Lookup
    builder.addCase(getExportLookup.pending, (state) => {
      state.exportData.status = 'loading';
    });
    builder.addCase(getExportLookup.fulfilled, (state, action) => {
      state.exportData.status = 'finished';
      state.exportData.data = action.payload;
    });
    builder.addCase(getExportLookup.rejected, (state) => {
      state.exportData.status = 'error';
    });
      
  }
});

export const { addFilter,addDashboardFilter, addSort, removeSort, clearAllFilters, setPaginationCurrentPage, setPaginationItemPerPage, setExportStatus, removeMasterSearchFilter,setQuickSummaryType,setViewType,setCurrentInsightID,setDetailedView,setReviewerOptionsRx,addExportFilter,setPostFilters,setReferenceToggle,setCommentStatus,clearExportFilter,addAllAnomalyFilters, setLastPageBeforeLandingDetailedPage } = allOpportunitiesSlice.actions;


export const getAllOpportunitiesSelector = (state: RootState) => state.allOpportunities.records;

export const getCurentOpportunitiesSelector = (state: RootState) => state.allOpportunities.record;

export const getFiltersSelector = (state: RootState) => state.allOpportunities.filter;

export const getDashboardFiltersSelector = (state: RootState) => state.allOpportunities.dashbaordfilter;

export const getAllAnomalyFiltersSelector = (state: RootState) => state.allOpportunities.anomaliesFilters;

export const getAllExportFiltersSelector = (state: RootState) => state.allOpportunities.exportFilters;

export const getSortSelector = (state: RootState) => state.allOpportunities.sort;

export const getPillsSelector = (state: RootState) => state.allOpportunities.pills;

export const getLookupStatusSelector = (state: RootState) => state.allOpportunities.statuslookup;

export const getSamplingStatusSelector = (state: RootState) => state.allOpportunities.samplingstatus;

export const getDetailedView = (state: RootState) => state.allOpportunities.detailedView;

export const getLastPageBeforeLandingDetailedPage = (state: RootState) => state.allOpportunities.lastPageBeforeLandingDetailedPage;

export const getExportLookupSelector = (state: RootState) => state.allOpportunities.exportData;

export const getCommentSelector = (state: RootState) => state.allOpportunities.comments;

export const getPaginationSelector = (state: RootState) => state.allOpportunities.pagination;

export const getQuickSummarySelector = (state: RootState) => state.allOpportunities.quicksummarytype;

export const getViewTypeSelector = (state: RootState) => state.allOpportunities.viewType;

export const getPostFiltersSelector = (state: RootState) => state.allOpportunities.postFilters;

export const getReferenceToggleSelector = (state: RootState) => state.allOpportunities.referenceToggle;

export default allOpportunitiesSlice.reducer;

export const buildFilterRequest = (filters: IFilterAPIModel[], pagination: IPaginationModel, sortData: ISortModel, QuickFiltertype:any ,currentRole:string,postFilters: IFilterAPIModel[] = []) => {
  let data:IOpportunityAPIDataModel =  { "page": pagination.currentPage > 0 ? pagination.currentPage : 1,  "rows_per_page": pagination.itemPerpage, sort: {},   "filters": [] as IFilterAPIModel[], "current_role":currentRole};
 
  let requestFilter: IFilterAPIModel[] = [];
  filters.forEach((item: IFilterAPIModel, index) => {
    if(item.groupName) {
      switch (item.groupName) {
        case FILTER_GROUP_NAMES.SEARCH:
          requestFilter.push({
            "column": item.column,
            "type": 'in',
            "value": item.value
          })
          break;
        case FILTER_GROUP_NAMES.EXPORT:
          requestFilter.push({
            "column": item.column,
            "type": 'in',
            "value": item.value
          })
          break;
        default:
        requestFilter.push({
          "column": item.column,
          "type": 'in',
          "value": item.value
        })
      }
    } else {
      requestFilter.push({
        "column": item.column,
        "type": 'in',
        "value": item.value
      })
    }
  })
  if(currentRole === USER_ROLE.ORG_USER){
    requestFilter=[...requestFilter, ...postFilters] 
  }
  data.filters = requestFilter;
  if (sortData.columnName) {
    data.sort = sortData;
  }
  if (QuickFiltertype.length>0) {
    data.view_type = QuickFiltertype;
  }else{
    if(data.view_type)
    {
      delete data["view_type"];
    }
  }
  return data;
}

